import React from "react";

const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_4033f70d-8f0b-4b41-8d5d-5eafa72d2f72/artifacts/fmm9mw4v_KellerWilliams_Realty_Wellington_Logo_RGB.png";

export const KWLogo = ({ className = "h-12 md:h-14" }) => {
  return (
    <img
      src={LOGO_URL}
      alt="Keller Williams Realty Wellington"
      className={`${className} w-auto object-contain select-none`}
      draggable={false}
    />
  );
};

export default KWLogo;
